import { LitElement, html, css, t } from '@hh/global.js'

class HHCartNotification extends LitElement {
  static properties = {}

  constructor() {
    super()
  }

  connectedCallback() {
    super.connectedCallback()
    window.addEventListener('productAdded', this.onProductAdded.bind(this))
  }

  disconnectedCallback() {
    super.disconnectedCallback()
    window.removeEventListener('productAdded', this.onProductAdded.bind(this))
  }

  firstUpdated() {
    this.defaultMessage = this.message.textContent
  }

  onProductAdded(event) {
    const productTitle = event?.detail?.product_title ?? ''

    const notificationMessage = t('sections.cart.notification_message')

    this.message =
      productTitle && notificationMessage
        ? notificationMessage.replace('{{ product_title }}', productTitle)
        : this.defaultMessage
  }

  get message() {
    const slot = this.shadowRoot.querySelector('slot[name="message"]')
    return slot?.assignedNodes()?.[0] ?? ''
  }

  set message(value) {
    if (!this.message) return
    this.message.innerHTML = value
  }

  render() {
    return html`
      <h2 class="heading">
        <slot name="icon"></slot>
        <slot name="message"></slot>
      </h2>
      <slot name="actions"></slot>
    `
  }

  static styles = css`
    :host *,
    :host *::before,
    :host *::after {
      box-sizing: border-box;
    }

    :host {
      display: block;
    }

    .heading {
      font: var(--hh-body-bold-lg-font);
      letter-spacing: var(--hh-body-bold-letter-spacing);
      max-width: 90%;
      align-items: center;
      display: flex;
      flex-grow: 1;
      margin: var(--hh-spacing-sm) 0;
      align-items: flex-start;
    }
  `
}

if (!customElements.get('hh-cart-notification')) {
  customElements.define('hh-cart-notification', HHCartNotification);
}